'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getCategoryPosts: { path: 'categories/:id/posts.json' },
  getCategoryInfo: { path: 'categories.json' },
  getPopular: { path: 'posts.json', params: { sort: 'popularity' } },
  getTrending: { path: 'posts.json', params: { sort: 'trending' } },
  getLatest: { path: 'posts.json', params: { sort: 'latest' } },
  getArticle: { path: 'posts/:id.json' },
  getFanClubPosts: { path: 'fanClubs/:id/posts.json' },
  getFCInfo: { path: 'fanClubs.json' },
  getTagPosts: { path: 'tags/:id/posts.json' },
  getTagInfo: { path: 'tags.json' },
  getSearch: { path: 'search.json' },
  getAuthorInfo: { path: 'authors/:id.json' },
  getAuthorPosts: { path: 'authors/:id/posts.json' },
  getLatestMusicChart: { path: 'music-charts.json' },
  getMusicChartRankings: { path: 'music-charts/:id/rankings.json' }
};


// WEBPACK FOOTER //
// ./submodules/soompi-js/dist/node/schema.js